import axios from "axios";

import { message, notification } from "antd";
// import { showSuccessNotification } from '../utils/notifications'
import {
  showNotyError,
  showNotySucess,
} from "../components/Common/notificationUtils";
import getCookie, { deleteCookie } from "../components/Common/Utils";
// import { showSuccessNotification } from '../utils/notifications'

export const detectionUrls = (env) => {
  switch (env) {
    case "dev":
      return "https://api.dev.detection.umgapps.com";

    case "qa":
      return "https://api.qa.detection.umgapps.com";

    case "uat":
      return "https://api.stage.detection.umgapps.com";

    case "prod":
      return "https://api.detection.umgapps.com";

    default:
      return "https://api.dev.detection.umgapps.com";
  }
};

const BASE_URL = detectionUrls(process.env.REACT_APP_ENV || "dev");

export const config = {
  headers: {
    "Content-Type": "application/json",
    detection_auth: getCookie("detection_auth"),
  },
};
// const navigate=useNavigate()
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response ? error.response.status : null;
    if (status === 401 || status === 403) {
      deleteCookie("detection_auth");
      // showNotyError("Timeout/Authorization Failed. Please Try again!");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export const getApi = async (params, url) => {
  const res = await axios.get(BASE_URL + url, {
    params: params,
    headers: {
      detection_auth: getCookie("detection_auth"),
    },
  });
  return res.data;
};

export const deleteApi = async (id, url, customMessage?) => {
  const res = await axios.delete(BASE_URL + url + `/${id}`, {
    headers: {
      detection_auth: getCookie("detection_auth"),
    },
  });
  showNotification(res.status, customMessage);
  return res.data;
};

export const deleteApiWithReqBody = async (payload, url, customMessage?) => {
  const res = await axios.delete(BASE_URL + url, {
    headers: {
      detection_auth: getCookie("detection_auth"),
    },
    data: payload,
  });
  showNotification(res.status, customMessage);
  return res.data;
};

export const postApi = async (data, url, customMessage) => {
  const res = await axios.post(BASE_URL + url, data, config);
  showNotification(res.status, customMessage);
  return res.data;
};

const showNotification = (status, customMessage) => {
  if (customMessage) {
    if (status === 200 || status === 201) {
      showNotySucess(customMessage);
    }

    if (status !== 200 && status !== 201) {
      showNotyError(customMessage);
    }
  }
};
